import {
  Button,
  FormControl,
  FormGroup,
  FormLabel,
  Paper,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { Stack } from "@mui/material"
import { FC, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { getItemsForRevision } from "../../../actions/inventoryCrossActions/InventoryCrossActions"
import { getItemTypes } from "../../../actions/itemTypeActions/ItemTypeActions"
import { ItemType } from "../../../actions/itemTypeActions/ItemTypeActionsTypes"
import { RootStore } from "../../../Store"
import useStyles from "./ItemSearchFiltersStyle"

interface ItemSearchFiltersProps {
  selectedVendor: string
}

const ItemSearchFilters: FC<ItemSearchFiltersProps> = ({ selectedVendor }) => {
  const [t] = useTranslation("global")
  const classes = useStyles()
  const dispatch = useDispatch()
  const itemsTypeState = useSelector((state: RootStore) => state.itemType)
  const itemsTypeList = itemsTypeState.itemTypeList?.categories
  const [availability, setAvailability] = useState<boolean>(true)
  const [category, setCategory] = useState<string>("")
  const [searchTerm, setSearchTerm] = useState<string>("")
  const selectedItemType =
    itemsTypeList?.find(
      (itemType: ItemType) => String(itemType.id) === String(category)
    ) ?? null
  const params = new URLSearchParams(window.location.search)
  let page = params.get("page")
  const location = useLocation()
  const handleAvailabilityButtonChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setAvailability(event.target.checked)
  }
  const handleResetButton = () => {
    setCategory("")
    setAvailability(true)
    setSearchTerm("")
    window.history.replaceState(null, "", location.pathname);
  }

  const handleSearchTermChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchTerm(event.target.value)
  }
  const onSearch = () => {
    dispatch(
      getItemsForRevision({
        vendorId: selectedVendor,
        itemType: parseInt(category),
        availability,
        searchTerm,
        paged: true,
        size: 10,
        page: page ? parseInt(page) - 1 : 0,
      })
    )
  }

  useEffect(() => {
    dispatch(getItemTypes())
  }, [dispatch])

  useEffect(() => {
    if (!category) {
      return
    }
    dispatch(
      getItemsForRevision({
        vendorId: selectedVendor,
        itemType: parseInt(category)!,
        availability,
        searchTerm,
        paged: true,
        size: 10,
        page: page ? parseInt(page) - 1 : 0,
      })
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, location])

  return (
    <Paper elevation={3}>
      <div className={classes.container}>
        <div className={classes.leftContainer}>
          <TextField
            id="item-name"
            label={t("inventoryCrossCheck.item-name")}
            value={searchTerm}
            onChange={handleSearchTermChange}
          ></TextField>

          <FormControl component="fieldset" variant="standard">
            <FormLabel component="legend">
              <Typography color="primary">
                {t("inventoryCrossCheck.stockAvailability")}
              </Typography>
            </FormLabel>
            <FormGroup>
              <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                <Switch
                  checked={availability}
                  onChange={handleAvailabilityButtonChange}
                  name="stockButton"
                  color="primary"
                />
                <Typography>{t("players.yes")}</Typography>
              </Stack>
            </FormGroup>
          </FormControl>
        </div>
        <div className={classes.rightContainer}>
          {/* The categories are typed on the field itself to filter them. */}
          <Autocomplete
            id="category-autocomplete"
            fullWidth
            options={itemsTypeList ?? []}
            value={selectedItemType}
            getOptionLabel={(itemType: ItemType) => itemType.name}
            getOptionSelected={(itemType: ItemType, value: ItemType) =>
              itemType.id === value.id
            }
            onChange={(event: any, itemType: ItemType | null) =>
              setCategory(itemType ? String(itemType.id) : "")
            }
            noOptionsText={t("inventoryCrossCheck.noCategoriesToShow")}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("inventoryCrossCheck.category")}
                placeholder={t("inventoryCrossCheck.search-category")}
              />
            )}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={onSearch}
            disabled={category === ""}
          >
            {t("inventoryCrossCheck.search")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleResetButton}
          >
            {t("inventoryCrossCheck.reset")}
          </Button>
        </div>
      </div>
    </Paper>
  )
}

export default ItemSearchFilters
